import {AttrsSchema, Component} from 'panel';
import copy from 'clipboard-copy';

import {reporter} from 'common/report/error-reporting';
import {Button, ButtonJsxProps} from 'common/components/button';
import {ToastType} from 'common/components/toast/types';
import {addToast} from 'common/components/toast-area/toast-manager';
import {defineAndMakeJsxFactory} from 'common/util/jsx';

import {template} from './template';
import css from './index.styl?inline';

interface CopyToClipboardButtonJsxProps extends ButtonJsxProps {
  attrs: {
    value: string;
  } & ButtonJsxProps['attrs'];
}

export class CopyToClipboardButton extends Component<EmptyObj, CopyToClipboardButtonJsxProps['attrs']> {
  static get attrsSchema(): AttrsSchema<CopyToClipboardButtonJsxProps['attrs']> {
    return {
      ...Button.attrsSchema,
      value: {
        description: `The value to be copied`,
        type: `string`,
      },
    };
  }

  get config() {
    return {
      useShadowDom: true,
      css,
      template,
      helpers: {
        copyValue: async () => {
          try {
            await copy(this.attr(`value`));
            addToast({type: ToastType.SUCCESS, message: `Link Copied!`});
          } catch (err) {
            reporter.error(err);
            addToast({type: ToastType.ERROR, message: `Something went wrong copying the link`});
          }
        },
      },
    };
  }
}

export const CopyToClipboardButtonEl = defineAndMakeJsxFactory<CopyToClipboardButtonJsxProps>(
  `mp-copy-to-clipboard-button`,
  CopyToClipboardButton,
);
